import { Menu } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import LanguageSwitcher from './LanguageSwitcher'

interface PartnerHeaderProps {
  onMenuClick: () => void
  partner: {
    name: string
    company?: string
  }
}

const PartnerHeader = ({ onMenuClick, partner }: PartnerHeaderProps) => {
  const { t } = useTranslation('header')

  return (
    <header className="glass border-b border-white/10 px-4 sm:px-6 py-3 sm:py-4 flex items-center justify-between">
      {/* Left side - Mobile menu button */}
      <div className="flex items-center space-x-4">
        <button
          onClick={onMenuClick}
          className="lg:hidden glass-button p-2 rounded-lg hover:bg-white/10 transition-colors duration-200"
        >
          <Menu className="w-5 h-5 text-white" />
        </button>

        {/* Welcome message - Hidden on mobile */}
        <div className="hidden sm:block">
          <h2 className="text-lg font-semibold text-white">
            {t('greeting', { name: partner.name })}
          </h2>
          <p className="text-sm text-dark-400">
            {t('welcome')}
          </p>
        </div>
      </div>

      {/* Right side - User info */}
      <div className="flex items-center space-x-3">
        {/* Language Switcher */}
        <LanguageSwitcher />

        {/* User info - Mobile */}
        <div className="sm:hidden flex items-center space-x-2">
          <div className="w-8 h-8 bg-gradient-to-br from-blue-500 to-blue-600 rounded-full flex items-center justify-center text-white font-bold text-sm">
            {partner.name[0] || 'P'}
          </div>
        </div>

        {/* User info - Desktop */}
        <div className="hidden sm:flex items-center space-x-3">
          <div className="text-right">
            <div className="text-sm font-medium text-white">{partner.name}</div>
            <div className="text-xs text-dark-400">{partner.company || t('defaultCompany')}</div>
          </div>
          <div className="w-10 h-10 bg-gradient-to-br from-blue-500 to-blue-600 rounded-full flex items-center justify-center text-white font-bold">
            {partner.name[0] || 'P'}
          </div>
        </div>
      </div>
    </header>
  )
}

export default PartnerHeader
